import { render, staticRenderFns } from "./ExceptionEdit.vue?vue&type=template&id=f0947aa4&scoped=true&"
import script from "./ExceptionEdit.vue?vue&type=script&lang=js&"
export * from "./ExceptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionEdit.vue?vue&type=style&index=0&id=f0947aa4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0947aa4",
  null
  
)

export default component.exports